// @flow
import React from 'react'
import I18n from 'i18n-react'
import Modal from 'reactstrap/lib/Modal'
import ModalBody from 'reactstrap/lib/ModalBody'
import ModalHeader from 'reactstrap/lib/ModalHeader'

// components
import { FieldLabel } from '../../Components'
import { String } from '../../Components/_formFields/'
import PhoneApp from '../../Components/_miniApps/PhoneApp'


import type { ValidationErrorsType } from '../Types/ValidationError'
import type { ProductContent } from '../Types/ProductContent'

type ModalProps = {
  content: ProductContent,
  formData: Object,
  id?: string,
  name?: string,
  onChangeFormData: (formData: Object, key?: Array<string>) => void,
  onChangeTitle: (string) => void,
  onSaveData: () => void,
  opened: boolean,
  productLinkData: { [key: string]: string },
  requestLinkId?: string,
  showToggle: () => void,
  validationErrors: ValidationErrorsType,
}

type ModalState = {
  pushIsPristine: boolean,
  saveDataModalOpened: boolean,
  validationErrors: ValidationErrorsType,
}

const inputs = ['productLinkTitle']

export default class SaveDataModal extends React.Component<ModalProps, ModalState> {
  static defaultProps = {
    requestLinkId: '',
  }

  state = {
    pushIsPristine: true,
    saveDataModalOpened: false,
    validationErrors: {
      productLinkTitle: { error_type: 'required_field_missing' }
    },
  }

  handleToggleSaveDataModal = () => {
    this.props.showToggle()
  }

  handleOnChangeTitle = (title: string) => {
    this.props.onChangeTitle(title)
    this.isValid('productLinkTitle', title)
  }

  handleSaveData = () => {
    this.validate(inputs)
    this.setState({ pushIsPristine: !this.state.pushIsPristine })
    if (Object.keys(this.state.validationErrors).length === 0 &&
      !(this.props.validationErrors.policyHolder && this.props.validationErrors.policyHolder.phoneNumber)) {
      this.props.onSaveData()
    }
  }

  validate = (inputKeys: Array<string>) => {
    const validationErrors = {}
    inputKeys.map(key => {
      switch (key) {
        case 'productLinkTitle':
          if (!this.props.productLinkData.title) {
            validationErrors[key] = { error_type: 'required_field_missing' }
          }
          break
      }
    })
    this.setState({ validationErrors })
  }

  isValid = (key: string, value: string) => {
    const validationErrors = {...this.state.validationErrors}
    delete validationErrors[key]

    switch (key) {
      case 'productLinkTitle':
        if (!value) {
          validationErrors[key] = { error_type: 'required_field_missing' }
        }
        break
    }
    this.setState({ validationErrors })
  }

  render = () => {
    const { opened, content, validationErrors, formData, productLinkData, requestLinkId } = this.props

    return (
      <Modal isOpen={opened} toggle={this.handleToggleSaveDataModal}>
        <ModalHeader className='mt-2'>
          <button
            className='close'
            onClick={this.handleToggleSaveDataModal}
            type='button'
          >
            <i className='pfp pfp-close'/>
          </button>
        </ModalHeader>
        <ModalBody>
          {typeof productLinkData.status === 'boolean' &&
          <div className={`alert alert-${productLinkData.status ? 'success' : 'danger'} text-center mt-1 mb-3`} role='alert'>
            {I18n.translate(`components.saveDataModal.status.${productLinkData.status ? 'success' : 'failure'}`)}
          </div>
          }
          {requestLinkId && requestLinkId.length > 0 && <div className='alert alert-info'>
            {I18n.translate('components.saveDataModal.currentlySaved', { linkId: requestLinkId })}
          </div>}
          <PhoneApp
            content={content}
            formData={formData}
            isBackOffice
            isBonusMalus={false}
            isInModal
            onChangeFieldVisibility={() => {}}
            onChangeFormData={(data: Object, keys: Array<string>) => {
              this.props.onChangeFormData(data, keys)
            }}
            pushIsPristine={this.state.pushIsPristine}
            // $FlowIssue
            validationErrors={validationErrors}
          />
          <div className='form-group d-flex flex-row flex-wrap flex-sm-row align-items-center'>
            <div className='col-10 col-sm-3 order-0 order-sm-0 pt-sm-2 mt-sm-1 text-sm-right'>
              <FieldLabel
                className='mb-0 mr-4 text-nowrap font-weight-bold'
                id='productLinkTitle'
                isRequired
                label={I18n.translate('general.description')}
              />
            </div>
            <div className='col-12 col-sm-5 order-3 order-sm-0 offset-sm-1 mt-2 mt-sm-0 pr-sm-0'>
              <String
                className='form-control mw-auto'
                enabled
                id='productLinkTitle'
                isPristine={this.state.pushIsPristine}
                name='productLinkTitle'
                onChange={this.handleOnChangeTitle}
                validationErrors={this.state.validationErrors}
                value={productLinkData.title}
              />
            </div>
          </div>
          <div className='text-center mt-4 py-2'>
            <button
              className='btn btn-secondary'
              onClick={this.handleSaveData}
              type='button'
            >
              {I18n.translate('general.saveData')}
            </button>
          </div>
        </ModalBody>
      </Modal>
    )
  }
}
